import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import MainView from "@/views/MainView.vue";
import LoginView from "@/views/LoginView.vue";
import { auth } from "@/store";

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: "/",
    name: "Main",
    component: MainView,
    beforeEnter(to, from, next) {
      if (auth.getters.isConfirmed) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/login",
    name: "Login",
    component: LoginView,
    beforeEnter(to, from, next) {
      if (!auth.getters.isConfirmed) {
        next();
      } else {
        next("/");
      }
    },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
